t = require('views/internal/teacup-with-helpers')('card_detail_list')

module.exports = t.renderable ({ editable, listName }) ->
  t.p '.u-inline-block.u-bottom', ->
    className = t.classify('js-open-move-from-header': editable, disabled: !editable)
    t.format 'in-list', { className, listName }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/card_detail_list.coffee